import {
    createRegisterableComponentWithData,
    EditionLoader,
} from '@news-mono/web-common'
import React from 'react'
import { EditionV4DTO } from '@west-australian-newspapers/publication-types'
import { NightlyPreviousSpecialEditionsV2 } from './PreviousSpecialEditionsV2'

export const NightlyPreviousSpecialEditionsV2Registration =
    createRegisterableComponentWithData(
        'nightly-previous-special-editions-v2',
        EditionLoader,

        ({ ...props }, data, services) => {
            if (!data.loaded) return null

            const editions = data.result.documents
            if (!editions) {
                services?.log?.error(
                    data,
                    'NightlyPreviousSpecialEditions: empty result',
                )
                return null
            }

            return (
                <NightlyPreviousSpecialEditionsV2
                    editions={editions}
                    title="Latest Nightly On Editions"
                />
            )
        },
    )
